// extracted by mini-css-extract-plugin
export default {"title":"styles_title__XLERv","sider":"styles_sider__FtLbo"};